import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import StorySection from "./components/StorySection";
import CharactersSection from "./components/CharactersSection";
import GallerySection from "./components/GallerySection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import SEOHead from "@/components/feature/SEOHead";

const homeSchema = [
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": `${import.meta.env.VITE_SITE_URL || ""}/#webpage`,
    "url": import.meta.env.VITE_SITE_URL || "",
    "name": "The Wraith – Jordan Reyes Zombie Survival Story | Post-Apocalyptic Chronicles",
    "description":
      "The Wraith Chronicles: Follow Jordan Reyes, a post-apocalyptic survivor fighting through the zombie wasteland to find Aidan. A story of survival, redemption, and love after Green Monday.",
    "inLanguage": "en",
    "isPartOf": {
      "@type": "WebSite",
      "@id": `${import.meta.env.VITE_SITE_URL || ""}/#website`,
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": `${import.meta.env.VITE_SITE_URL || ""}/#website`,
    "name": "The Wraith Chronicles",
    "url": import.meta.env.VITE_SITE_URL || "",
    "description":
      "The Wraith Chronicles: Follow Jordan Reyes, a post-apocalyptic survivor fighting through the zombie wasteland to find Aidan after Green Monday.",
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${import.meta.env.VITE_SITE_URL || ""}/lore?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "CreativeWorkSeries",
    "name": "The Wraith Chronicles",
    "alternateName": "The Wraith",
    "description":
      "A post-apocalyptic survival story following Jordan 'The Wraith' Reyes and Aidan Lee after Green Monday changed the world forever.",
    "genre": ["Post-Apocalyptic Fiction", "Zombie Survival", "Romance"],
    "url": import.meta.env.VITE_SITE_URL || "",
    "character": [
      { "@type": "Person", "name": "Jordan Reyes", "alternateName": "The Wraith" },
      { "@type": "Person", "name": "Aidan Lee", "alternateName": "The Chef" },
    ],
  },
];

export default function Home() {
  return (
    <div className="bg-[#0A0A0A] min-h-screen w-full">
      <SEOHead
        title="The Wraith – Jordan Reyes Zombie Survival Story | Post-Apocalyptic Chronicles"
        description="The Wraith Chronicles: Follow Jordan Reyes, a post-apocalyptic survivor fighting through the zombie wasteland to find Aidan. A story of survival, redemption, and love after Green Monday."
        keywords="The Wraith, Jordan Reyes, zombie survival, post-apocalyptic story, Green Monday, Aidan Lee"
        canonical="/"
        ogTitle="The Wraith – Jordan Reyes | Post-Apocalyptic Survival Story"
        ogDescription="She already lost him once. She will not let it happen again. Follow The Wraith through the zombie wasteland."
        ogType="website"
        schema={homeSchema}
      />
      <Navbar />
      <HeroSection />
      <AboutSection />
      <StorySection />
      <CharactersSection />
      <GallerySection />
      <ContactSection />
      <Footer />
    </div>
  );
}
